<template>
  <div>
    <v-card class="box-container ma-0 pa-2" align="center" justify="center" :min-width="360">
      <v-card-actions class="row-header ma-0 pa-4">
        <v-col class="ma-0 pa-0">
          <v-row class="ma-0 pa-0" align="center" justify="center">
            <span class="title">{{ title }}</span>
          </v-row>
          <v-divider></v-divider>
        </v-col>
      </v-card-actions>
      <v-card-actions class="row-content">
        <v-col class="ma-0 pa-0">
          <v-text-field v-model="data" :placeholder="placeholder" autofocus></v-text-field>
        </v-col>
      </v-card-actions>
      <v-card-actions class="row-header ma-0 pa-0">
        <v-row class="ma-2 pa-0" align="center" justify="space-between">
          <v-card v-if="buttonCancelText" align="center" :width="100" style="display: flex; cursor: pointer; height: 100%" :color="Colors.IconColor" class="pa-2 white--text" @click="resolve(null)">
            <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonCancelText }}</span>
          </v-card>
          <v-card v-if="buttonYesText" align="center" :width="100" style="display: flex; cursor: pointer; height: 100%" :color="Colors.IconColor" class="pa-2 white--text" @click="resolve(true)">
            <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonYesText }}</span>
          </v-card>
          <v-card v-if="buttonNoText" align="center" :width="100" style="display: flex; cursor: pointer; height: 100%" :color="Colors.IconColor" class="pa-2 white--text" @click="resolve(false)">
            <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonNoText }}</span>
          </v-card>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      title: "",
      data: null,
      data_orignal: null,
      placeholder: "",
      buttonYesText: "",
      buttonNoText: "",
      buttonCancelText: "",
    };
  },
  computed: {},
  methods: {
    resolve(result) {
      if (result == true) {
        this.dialog.result = this.data;
      } else if (result == false) {
        this.dialog.result = this.data_orignal;
      } else {
        this.dialog.result = null;
      }
      this.dialog.close();
    },
  },
  created() {
    if (this.dialog.options) {
      this.data = this.dialog.data;
      this.data_orignal = this.data;
      this.title = this.dialog.options.title;
      this.placeholder = this.dialog.options.placeholder;
      if (this.dialog.options.buttonYesText != undefined) {
        this.buttonYesText = this.dialog.options.buttonYesText;
      }
      if (this.dialog.options.buttonNoText != undefined) {
        this.buttonNoText = this.dialog.options.buttonNoText;
      }
      if (this.dialog.options.buttonCancelText != undefined) {
        this.buttonCancelText = this.dialog.options.buttonCancelText;
      }
    }
  },
  mounted() {},
};
</script>
